import axios from 'axios';

let debug = require('debug')('APP:API')

let apiRootPath = ''
if (process.env.NODE_ENV === 'production') {
    apiRootPath = window.location.protocol + '//' + window.location.host;
} else {
    apiRootPath = 'http://213.219.37.56';
}

class Api {

    username = '';
    token = '';

    setAuth(username: string, token: string) {
        this.username = username;
        this.token = token;
    }

    public acquire() {
        let uri = this.buildUri('/api/ios/acquire.json', 'location=hk');
        return axios.get(uri);
    }

    public locations() {
        let uri = this.buildUri('/api/locations.json');
        return axios.get(uri);
    }

    public vipRecover(paymentId: string) {
        let uri = this.buildUri('/api/vipRecover.json', 'paymentId=' + paymentId);
        return axios.get(uri);
    }

    /**
     *
     * @param {string} username
     * @param {string} secret               md5(username+deviceId)
     * @param {string} deviceId
     * @param {string} deviceName
     * @returns {Promise<AxiosResponse<T>>}
     */
    public autoRegister(username: string, secret: string, deviceId: string, deviceName: string) {
        let channel = 'ios1'
        let splits = window.location.search.match(RegExp('channel=(.*)'))
        if (splits !== null) {
            channel = splits[1]
        }
        let uri = this.buildUriWithoutAuth('/api/autoRegister.json',
            'username=' + username,
            'secret=' + secret,
            'deviceId=' + deviceId,
            'deviceName=' + deviceName,
            'channel=' + channel);
        return axios.get(uri);
    }

    public vipRenewLog() {
        let uri = this.buildUri('/api/payment/vipRenewLog.json');
        return axios.get(uri);
    }

    public listTicket() {
        let uri = this.buildUri('/api/ticket/listTicket.json');
        return axios.get(uri);
    }

    public aliPayH5XCharge(productId: string,extra: string) {
        let uri = this.buildUri('/api/payment/aliPayH5Charge.json', 'paymentChannel=alipay', 'productId=' + productId,'extra=' + extra)
        return axios.get(uri);
    }
    public ppH5XCharge(productId: string,extra:string) {
        let uri = this.buildUri('/api/payment/ppH5Charge.json', 'paymentChannel=pp', 'productId=' + productId,'extra=' + extra)
        return axios.get(uri);
    }
    public upH5XCharge(productId: string,extra:string) {
        let uri = this.buildUri('/api/payment/h5Charge.json', 'paymentChannel=up', 'productId=' + productId,'extra=' + extra)
        return axios.get(uri);
    }

    public wxH5XCharge(productId: string,extra:string) {
        let uri = this.buildUri('/api/payment/wxH5Charge.json', 'paymentChannel=wx', 'productId=' + productId,'extra=' + extra)
        return axios.get(uri);
    }

    public paymentCheck(orderId: string) {
        let uri = this.buildUri('/api/payment/iosPaymentCheck.json', 'orderId=' + orderId);
        return axios.get(uri);
    }

    public addQuestion(content: string) {
        return this.post('/api/ticket/new.json', {content: content})
    }

    public getTicketdetail(ticketId: string) {
        let uri = this.buildUri('/api/ticket/ticketDetail.json', 'ticketId=' + ticketId);
        return axios.get(uri)
    }

    public replyQuestion(ticketId: string, content: string) {
        return this.post('/api/ticket/reply.json', {ticketId: ticketId, content: content})
    }

    /**
     * 构建api请求uri
     * @param {string} apiPath
     * @param {string} params
     */
    private buildUri(apiPath: string, ...params: string[]): string {
        let uri = apiRootPath + apiPath + '?username=' + this.username + '&token=' + this.token
            + '&platform=ios&alias=sky&channel=ios1';
        for (let i = 0; i < params.length; i++) {
            uri += '&' + params[i];
        }
        return uri;
    }


    private buildUriWithoutAuth(apiPath: string, ...params: string[]): string {
        let uri = apiRootPath + apiPath + '?platform=ios&alias=sky';
        for (let i = 0; i < params.length; i++) {
            uri += '&' + params[i];
        }
        return uri;
    }

    public get(apiPath: string, ...params: [string]) {
        let uri = this.buildUri(apiPath, ...params)
        return axios.get(uri)
    }

    public post(apiPath: String, params: {}) {
        let param = new URLSearchParams();
        param.append('username', this.username);
        param.append('token', this.token);
        param.append('platform', 'ios');
        param.append('alias', 'sky');
        param.append('channel', 'ios1');

        let ua = window.navigator.userAgent;
        param.append('log', encodeURI('userAgent=') + ua);

        Object.keys(params).forEach(function(key){
            // @ts-ignore
            param.append(key, params[key])
        });

        // param.append('content', '测试');

        let url = apiRootPath + apiPath;
        return new Promise<any>((resolve, reject) => {
            axios.post(url, param).then(res => {
                resolve(res);
                console.log(res);
            }).catch(err => {
                reject(err.data);
                //msg.suspensionMsg('网络请求异常');
                console.log(err);
            });
        });
    }

    public postWithAuth(uri: String, params: any) {
        let url = apiRootPath + uri;
        params.access_token = this.token;
        return new Promise<any>((resolve, reject) => {
            axios.post(url, params).then(res => {
                resolve(res.data);
                console.log(res);
                console.log(res.data);
            }).catch(err => {
                reject(err.data);
                //msg.suspensionMsg('网络请求异常');
                console.log(err);
            });
        });
    }

}

//let api = new Api();

export default Api;
